import { apiGet } from "./api";

export const fetchAccountInfo = async () => {
      
        try {
          const res = await apiGet('user-info/');
          return res
        } catch (err) {
          return err
        }
};